@defer (hydrate on immediate) {
	<div class="flex flex-col gap-10 pt-28">
		<div class="flex flex-col md:flex-row justify-around items-center gap-4">
			<peps-title
				[subtitle]="'page.home.news.subtitle' | translate"
				[title]="'page.home.news.title' | translate"
			></peps-title>
			<div class="border border-peps-dark-600 flex flex-col gap-2 py-3 px-6 bg-peps-dark-700">
				<span class="text-base tracking-tight text-center font-dinpro-medium uppercase">{{ 'page.home.filter' | translate }}</span>
				<div class="flex flex-row gap-2 items-center justify-center">
					<peps-checkbox
						[checked]="filter.includes(ArticleType.OVERWATCH)"
						(onCheckChange)="filterArticles([ArticleType.OVERWATCH], $event)"
						image="assets/images/max_button/max_button_overwatch.png"
						alt="Overwatch logo"
					></peps-checkbox>
					<peps-checkbox
						[checked]="filter.includes(ArticleType.MARVEL_RIVALS)"
						(onCheckChange)="filterArticles([ArticleType.MARVEL_RIVALS], $event)"
						image="assets/icons/Marvel_Rivals_logo.svg"
						alt="Marvel Rivals logo"
					></peps-checkbox>
					<peps-checkbox
						[checked]="filter.includes(ArticleType.TEAM_PEPS)"
						(onCheckChange)="filterArticles([ArticleType.TEAM_PEPS], $event)"
						image="assets/images/team_peps_logo.avif"
						alt="Team Peps logo"
					></peps-checkbox>
					<peps-checkbox
						[checked]="filter.includes(ArticleType.POKEMON_VGC)"
						(onCheckChange)="filterArticles([ArticleType.POKEMON_VGC, ArticleType.POKEMON_UNITE], $event)"
						image="assets/icons/pokemon_vgc_logo.svg"
						alt="Pokemon logo"
					></peps-checkbox>
					<peps-checkbox
						[checked]="filter.includes(ArticleType.DOFUS)"
						(onCheckChange)="filterArticles([ArticleType.DOFUS], $event)"
						image="assets/images/logo/dofus.png"
						alt="Dofus logo"
					></peps-checkbox>
				</div>
			</div>
		</div>
		<div class="flex flex-row flex-wrap gap-x-12 gap-y-16 justify-center items-center">
			@if(articles.length > 0) {
				@for (article of articles; track article.id) {
					<peps-news-card
						[article]="article"
					></peps-news-card>
				}
			} @else {
				<peps-no-content
					[text]="'component.no-news.text' | translate"
				></peps-no-content>
			}

		</div>

		@if(totalPages > 1) {
			<peps-page-selector
				[page]="page"
				[totalPages]="totalPages"
				(pageChange)="onPageChange($event)"
			></peps-page-selector>
		}
		<peps-last-videos></peps-last-videos>

	</div>
}
